/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { KeycloakProfile } from "keycloak-js";

const emptyProfile = {
  id: "",
  username: "",
  email: "",
  lastName: "",
  firstName: "",
};

const ProfilePage = () => {
  const { keycloak } = useKeycloak();
  const [userProfile, setUserProfile] = useState<KeycloakProfile>(emptyProfile);

  useEffect(() => {
    keycloak.loadUserProfile().then((profile: KeycloakProfile) => {
      setUserProfile(profile);
    });
  }, [keycloak]);

  if (keycloak) {
    if (keycloak.authenticated)
      return (
        <div className="page">
          <p>
            The Profile Page is a Keycloak-secured component of your
            application. You shouldn't be able to see this unless you've
            authenticated with Keycloak.
          </p>
          <p>
            Sub: {keycloak.tokenParsed?.sub} <br></br>
            Username:{" "}
            {!!keycloak.tokenParsed &&
              keycloak.tokenParsed.preferred_username}{" "}
            <br></br>
            Full Name: {userProfile.firstName} {userProfile.lastName}
            <br></br>
            Token: {keycloak.token}
          </p>
        </div>
      );
    else return <div className="page">Unable to authenticate!</div>;
  }

  return <div>Initializing Keycloak...</div>;
};

export default ProfilePage;
